<template>
  <div class="edit-form-container">
    <!-- 物料信息 -->
    <div class="section">
      <div class="section-title">
        {{ $l('form_label_material_info') || '物料信息' }}
      </div>
      <el-form
        size="mini"
        ref="form"
        :model="formData"
        :disabled="disabled"
        :validate-on-rule-change="false"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_materialNo') || '物料编码'"
              prop="materialNo"
            >
              <el-input v-model="formData.materialNo" readonly>
                <el-button
                  slot="append"
                  icon="el-icon-more"
                  @click="openChooseMaterial"
                  :disabled="disabled || !!inspectionCode"
                ></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$l('form_label_materialName') || '物料名称'">
              <el-input
                v-model="formData.materialName"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$l('form_label_cd') || 'CD#'">
              <el-input
                v-model="formData.cd"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_materialDesc') || '规格型号'">
              <el-input
                v-model="formData.materialDesc"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_materialRequirement') || '材质要求'"
            >
              <el-input
                v-model="formData.materialRequirement"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_series') || '系列'">
              <el-input
                v-model="formData.series"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_purchaseMaterialNo') || '采购单号'"
            >
              <el-input
                v-model="formData.purchaseMaterialNo"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$l('form_label_originOrderNo') || '源头单号'">
              <el-input
                v-model="formData.originOrderNo"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item :label="$l('form_label_buyerName') || '采购人员'">
              <el-input
                v-model="formData.buyerName"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$l('form_label_scmName') || '供方'">
              <el-input
                v-model="formData.scmName"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              :label="$l('form_label_purchaserEntityName') || '需方'"
            >
              <el-input
                v-model="formData.purchaserEntityName"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 入库登记 -->
    <div class="section">
      <div class="section-title">
        {{ $l('form_label_storage_registration') || '入库登记' }}
      </div>
      <el-form
        size="mini"
        :rules="rules"
        ref="registrationForm"
        :model="formData"
        :disabled="disabled || !isEditRegister"
        :validate-on-rule-change="false"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_arrivalDate') || '实际到料日期'"
              prop="arrivalDate"
            >
              <el-date-picker
                v-model="formData.arrivalDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                format="yyyy/MM/dd"
                :placeholder="$l('form_placeholder_arrivalDate') || '请选择'"
                style="width: 100%"
                :picker-options="pickerOptions"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalArrivalQuantity') || '来料总量'"
              prop="totalArrivalQuantity"
            >
              <el-input-number
                v-model="formData.totalArrivalQuantity"
                :controls="false"
                style="width:100%"
                :precision="0"
                :max="999999999"
                :min="0"
                v-el-inputnumber-default0
              />
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
              :label="$l('form_label_whReceiverNames') || '仓库收货人员'"
              prop="whReceiverNames"
            >
              <ChooseUser
                v-model="formData.whReceiverNames"
                :placeholder="
                  $l('form_placeholder_whReceiverNames') || '请选择仓库收货人员'
                "
                clearable
                filterable
                multiple
                size="mini"
                :disabled="disabled"
                style="width: 100%"
                @confirm="chooseWhReceiverConfirm"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 入库检验 -->
    <div class="section">
      <div class="section-title">
        {{ $l('form_label_storage_inspection') || '入库检验' }}
      </div>
      <el-form
        size="mini"
        :rules="rules"
        ref="inspectionForm"
        :model="formData"
        :disabled="disabled || !isEditInspection"
        :validate-on-rule-change="false"
        label-position="top"
      >
        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_inspectionDate') || '检验日期'"
              prop="inspectionDate"
            >
              <el-date-picker
                v-model="formData.inspectionDate"
                type="date"
                size="mini"
                value-format="yyyy-MM-dd"
                format="yyyy/MM/dd"
                :placeholder="$l('form_placeholder_inspectionDate') || '请选择'"
                :picker-options="inspectionDatePickerOptions"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="20">
            <el-form-item
              :label="$l('form_label_reporterNames') || '检验人员'"
              prop="reporterNames"
            >
              <ChooseUser
                v-model="formData.reporterNames"
                :placeholder="
                  $l('form_placeholder_reporterNames') || '请选择检验人员'
                "
                clearable
                filterable
                multiple
                size="mini"
                :disabled="disabled"
                style="width: 100%"
                @confirm="chooseUserConfirm"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalInspectQuantity') || '抽检数量'"
              prop="totalInspectQuantity"
            >
              <el-input-number
                v-model="formData.totalInspectQuantity"
                :controls="false"
                style="width:100%"
                :precision="0"
                :max="formData.totalArrivalQuantity"
                :min="0"
                v-el-inputnumber-default0
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalQualifiedQuantity') || '抽检合格数量'"
            >
              <el-input
                v-model="formData.totalQualifiedQuantity"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalDefectiveQuantity') || '不良数量'"
            >
              <el-input
                v-model="formData.totalDefectiveQuantity"
                size="mini"
                readonly
                disabled
                :class="{
                  'defective-quantity': formData.totalDefectiveQuantity > 0
                }"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_totalQualifiedRate') || '合格率'"
            >
              <el-input
                :value="v_inspectionPassRate"
                size="mini"
                readonly
                disabled
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              :label="$l('form_label_inspectionResult') || '判定结果'"
            >
              <el-input
                :value="v_inspectionResult"
                size="mini"
                readonly
                disabled
                :class="inspectionResultClass"
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <!-- 重大问题 -->
    <div class="section">
      <div class="section-header">
        <div class="header-left">
          <span class="section-title">{{
            $l('form_label_major_issues') || '重大问题'
          }}</span>
          <el-button
            v-if="isEditInspection"
            :disabled="disabled"
            type="danger"
            size="small"
            @click="chooseMajorIssue"
          >
            {{ $l('btn_choose_issue') || '选择问题' }}
          </el-button>
        </div>
        <div class="header-right"></div>
      </div>
      <IssueTable
        :data="majorIssueList"
        :disabled="!isEditInspection || disabled"
        @delete="delMajorIssue"
      />
    </div>

    <!-- 疵点明细(不良明细) -->
    <div class="section">
      <div class="section-header">
        <div class="header-left">
          <span class="section-title">{{
            $l('form_label_defect_details') || '疵点明细'
          }}</span>
          <el-button
            v-if="isEditInspection"
            :disabled="disabled"
            type="primary"
            plain
            size="small"
            @click="chooseDefectIssue"
          >
            {{ $l('btn_defect_add') || '疵点+1' }}
          </el-button>
        </div>
        <div class="header-right"></div>
      </div>
      <DefectTable
        :data="defectIssueList"
        :disabled="!isEditInspection || disabled"
        @delete="delDefectIssue"
        @subQuantity="subDefectQuantity"
      />
    </div>

    <!-- 对话框和抽屉 -->
    <el-dialog
      append-to-body
      :title="$l('dialog_title_confirm') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('tips_save_confirm') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <ChooseMaterialPurchase
      :visible.sync="chooseMaterialVisible"
      confirm-on-close
      reserve
      @confirm="chooseMaterialConfirm"
    />

    <DefectIssuesDrawer
      v-model="issueDrawerVisible"
      :head-title="issueDrawerTitle"
      :content-title="issueDrawerContentTitle"
      :issue-type="issueDrawerType"
      @confirm="issueDrawerConfirm"
    />

    <UnqualifiedDrawer
      v-model="unqualifiedDrawerVisible"
      :inspection-code="inspectionCode"
      @confirm="handleUnqualifiedConfirm"
    />
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'
import { divideDown, subtract, multiply } from '@/libs/util.number.js'
import ChooseMaterialPurchase from '../choose-material-purchase'
import ChooseUser from '@/views/factory/quality/fabricInspectionReport/components/choose-user'
import DefectIssuesDrawer from '../defect-issues-drawer'
import UnqualifiedDrawer from '../unqualified-drawer'
import IssueTable from '../issue-table'
import DefectTable from '../defect-table'
import dayjs from 'dayjs'

export default {
  mixins: [EditLoading],
  components: {
    ChooseMaterialPurchase,
    ChooseUser,
    DefectIssuesDrawer,
    UnqualifiedDrawer,
    IssueTable,
    DefectTable
  },
  props: {
    inspectionCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    status: { type: String, default: 'N' }
  },
  watch: {
    'formData.totalInspectQuantity': {
      handler() {
        this.calculateResult()
      }
    },
    'formData.totalDefectiveQuantity': {
      handler() {
        this.calculateResult()
      }
    }
  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          // 禁用今天之后的日期
          return dayjs(time).isAfter(dayjs(), 'day')
        }
      },
      backDialogVisible: false,
      chooseMaterialVisible: false,
      formData: {
        // 默认今天
        arrivalDate: dayjs().format('YYYY-MM-DD'),
        inspectionDate: '',
        totalArrivalQuantity: null,
        totalInspectQuantity: null,
        totalDefectiveQuantity: 0,
        totalQualifiedQuantity: 0,
        totalQualifiedRate: 0,
        inspectionResult: '',
        totalLetGoQuantity: 0,
        inStockQuantity: 0,
        totalReturnQuantity: 0,
        reporterList: []
      },
      userNameList: [],
      majorIssueList: [],
      defectIssueList: [],
      issueDrawerVisible: false,
      issueDrawerTitle: '',
      issueDrawerContentTitle: '',
      issueDrawerType: '',
      unqualifiedDrawerVisible: false,
      inspectionResultMap: {
        Y: '合格',
        N: '不合格'
      }
    }
  },
  computed: {
    // 入库登记是否可编辑
    isEditRegister() {
      return ['N'].includes(this.status)
    },
    // 入库检验是否可编辑
    isEditInspection() {
      return ['Q'].includes(this.status)
    },
    // 实时计算判定结果
    computedInspectionResult() {
      const inspectQty = Number(this.formData.totalInspectQuantity) || 0
      const defectQty = Number(this.formData.totalDefectiveQuantity) || 0

      if (inspectQty === 0) return ''

      // 只要出现一条重大问题，直接判定不合格
      if (this.majorIssueList.length > 0) {
        return 'N'
      }

      // 没有重大问题时，抽检合格率 >= 95%，判定合格，否则判定不合格
      const qualifiedQty = inspectQty - defectQty
      const qualifiedRate = (qualifiedQty / inspectQty) * 100

      return qualifiedRate >= 95 ? 'Y' : 'N'
    },
    v_inspectionResult() {
      const result =
        this.computedInspectionResult || this.formData.inspectionResult
      return this.inspectionResultMap[result] || '未判定'
    },
    inspectionResultClass() {
      const result =
        this.computedInspectionResult || this.formData.inspectionResult
      if (result === 'Y') {
        return 'result-qualified'
      } else if (result === 'N') {
        const defectQty = Number(this.formData.totalDefectiveQuantity) || 0
        return defectQty > 0 ? 'result-defective' : 'result-unqualified'
      }
      return ''
    },
    inspectionPassRate() {
      const {
        totalInspectQuantity = 0,
        totalDefectiveQuantity = 0
      } = this.formData

      if (totalInspectQuantity === 0) return 0

      return multiply(
        divideDown(
          subtract(totalInspectQuantity, totalDefectiveQuantity),
          totalInspectQuantity,
          4
        ),
        100
      )
    },
    v_inspectionPassRate() {
      return this.inspectionPassRate
        ? this.inspectionPassRate.toFixed(2) + '%'
        : '0.00%'
    },
    inspectionDatePickerOptions() {
      const arrivalDate = this.formData.arrivalDate
      const today = dayjs().format('YYYY-MM-DD')

      return {
        disabledDate: (time) => {
          const date = dayjs(time).format('YYYY-MM-DD')
          // 检验日期不能大于当前日期
          if (dayjs(date).isAfter(today, 'day')) {
            return true
          }
          // 检验日期不能小于到料日期
          if (arrivalDate && dayjs(date).isBefore(arrivalDate, 'day')) {
            return true
          }
          return false
        }
      }
    },
    rules() {
      return {}
    }
  },
  methods: {
    async getData() {
      if (!this.inspectionCode) return

      try {
        const res = await this.$api.materialInspectionDetailApi({
          inspectionCode: this.inspectionCode,
          reporterType: 'I'
        })

        if (res.status === 200 && res.body) {
          this.formData = res.body
          this.$emit('loadData', { ...res.body })
        }
      } catch (error) {
        console.error('Load detail error:', error)
      }

      // 加载重大问题列表
      await this.loadMajorIssueList()
      // 加载疵点明细列表
      await this.loadDefectIssueList()
    },

    async loadMajorIssueList() {
      if (!this.inspectionCode) return

      try {
        const res = await this.$api.materialInspectionDefectList({
          inspectionCode: this.inspectionCode,
          issueType: 'B'
        })

        if (res.status === 200 && res.body?.data) {
          this.majorIssueList = res.body.data
        }
      } catch (error) {
        console.error('Load major issue list error:', error)
      }
    },

    async loadDefectIssueList() {
      if (!this.inspectionCode) return

      try {
        const res = await this.$api.materialInspectionDefectList({
          inspectionCode: this.inspectionCode,
          issueType: 'D'
        })

        if (res.status === 200 && res.body?.data) {
          this.defectIssueList = res.body.data
          this.updateDefectQuantity()
        }
      } catch (error) {
        console.error('Load defect issue list error:', error)
      }
    },

    calculateResult() {
      const inspectQty = Number(this.formData.totalInspectQuantity) || 0
      const defectQty = Number(this.formData.totalDefectiveQuantity) || 0
      const qualified = inspectQty > defectQty ? inspectQty - defectQty : 0

      this.formData.totalQualifiedQuantity = qualified

      if (inspectQty > 0) {
        const rawRate = (qualified / inspectQty) * 100
        this.formData.totalQualifiedRate = rawRate.toFixed(2)
      } else {
        this.formData.totalQualifiedRate = 0
      }

      this.formData.inspectionResult = this.computedInspectionResult
    },

    updateDefectQuantity() {
      const total = this.defectIssueList.reduce(
        (sum, item) => sum + (Number(item.quantity) || 0),
        0
      )
      this.formData.totalDefectiveQuantity = total
      this.calculateResult()
    },

    // 重大问题相关
    chooseMajorIssue() {
      this.issueDrawerVisible = true
      this.issueDrawerTitle = this.$l('dialog_title_choose_issue') || '选择问题'
      this.issueDrawerContentTitle =
        this.$l('form_label_major_issue') || '重大问题'
      this.issueDrawerType = 'B'
    },

    async delMajorIssue({ row, index }) {
      if (!row.inspectionDefectCode) {
        this.majorIssueList.splice(index, 1)
        this.formData.inspectionResult = this.computedInspectionResult
        return
      }

      this.$confirm(
        this.$l('tips_delete_major_issue') || '确定要删除该重大问题吗？',
        this.$l('dialog_title_confirm') || '确认删除',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(async () => {
          const baseInfo = this.validateAndBuildBaseInfo()
          if (!baseInfo) return

          this.loadingOpen()
          try {
            const res = await this.$api.materialInspectionDefectDel({
              inspectionDefectCode: row.inspectionDefectCode,
              baseInfo
            })

            if (res.status === 200) {
              this.$message.success(
                this.$l('tips_delete_success') || '删除成功'
              )
              await this.getData()
            } else {
              this.$message.error(res.msg || '删除失败')
            }
          } catch (error) {
            this.$message.error(error.message || '删除失败')
          } finally {
            this.loadingClose()
          }
        })
        .catch(() => {})
    },

    // 疵点明细相关
    chooseDefectIssue() {
      this.issueDrawerVisible = true
      this.issueDrawerTitle =
        this.$l('dialog_title_choose_defect') || '不良问题选择'
      this.issueDrawerContentTitle =
        this.$l('form_label_defect_reason') || '不良原因选择'
      this.issueDrawerType = 'D'
    },

    async delDefectIssue({ row, index }) {
      if (!row.inspectionDefectCode) {
        this.defectIssueList.splice(index, 1)
        this.updateDefectQuantity()
        return
      }

      this.$confirm(
        this.$l('tips_delete_defect') || '确定要删除该不良明细吗？',
        this.$l('dialog_title_confirm') || '确认删除',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(async () => {
          // 先计算删除后的不良数量
          const newTotalDefectiveQuantity = this.defectIssueList
            .filter((item, i) => i !== index)
            .reduce((sum, item) => sum + (Number(item.quantity) || 0), 0)
          
          const baseInfo = this.validateAndBuildBaseInfo()
          if (!baseInfo) return

          // 更新baseInfo中的不良数量为删除后的值
          baseInfo.totalDefectiveQuantity = newTotalDefectiveQuantity

          this.loadingOpen()
          try {
            const res = await this.$api.materialInspectionDefectDel({
              inspectionDefectCode: row.inspectionDefectCode,
              baseInfo
            })

            if (res.status === 200) {
              this.$message.success(
                this.$l('tips_delete_success') || '删除成功'
              )
              await this.getData()
            } else {
              this.$message.error(res.msg || '删除失败')
            }
          } catch (error) {
            this.$message.error(error.message || '删除失败')
          } finally {
            this.loadingClose()
          }
        })
        .catch(() => {})
    },

    async subDefectQuantity({ row, index }) {
      if (!row.inspectionDefectCode) {
        if (row.quantity <= 1) {
          this.defectIssueList.splice(index, 1)
        } else {
          row.quantity -= 1
        }
        this.updateDefectQuantity()
        return
      }

      const isDelete = row.quantity <= 1
      const confirmText = isDelete
        ? this.$l('tips_subtract_to_delete') ||
          '数量减至0将删除该记录，是否继续？'
        : this.$l('tips_subtract_confirm') || '确定要减少数量吗？'

      this.$confirm(
        confirmText,
        this.$l('dialog_title_confirm') || '确认操作',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(async () => {
          // 先计算减少后的不良数量
          const newTotalDefectiveQuantity = this.defectIssueList.reduce(
            (sum, item, i) => {
              if (i === index) {
                // 如果是当前行，判断是删除还是减少
                return isDelete ? sum : sum + (Number(item.quantity) || 0) - 1
              }
              return sum + (Number(item.quantity) || 0)
            },
            0
          )
          
          const baseInfo = this.validateAndBuildBaseInfo()
          if (!baseInfo) return

          // 更新baseInfo中的不良数量为减少后的值
          baseInfo.totalDefectiveQuantity = newTotalDefectiveQuantity

          this.loadingOpen()
          try {
            let res
            if (isDelete) {
              res = await this.$api.materialInspectionDefectDel({
                inspectionDefectCode: row.inspectionDefectCode,
                baseInfo
              })
            } else {
              res = await this.$api.materialInspectionDefectSubtract({
                inspectionDefectCode: row.inspectionDefectCode,
                baseInfo
              })
            }

            if (res.status === 200) {
              this.$message.success(
                this.$l('tips_operation_success') || '操作成功'
              )
              await this.getData()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          } catch (error) {
            this.$message.error(error.message || '操作失败')
          } finally {
            this.loadingClose()
          }
        })
        .catch(() => {})
    },

    async issueDrawerConfirm(items) {
      if (!items || items.length === 0) return

      const issueType = this.issueDrawerType

      if (issueType === 'B') {
        // 重大问题
        const newItems = items.filter((item) => {
          const existingItem = this.majorIssueList.find(
            (i) => i.defectIssuesCode === item.defectIssuesCode
          )
          if (!existingItem) {
            return true
          }
          return (item.defectIssuesTitle || '').trim() === '其他'
        })

        if (newItems.length > 0) {
          if (this.inspectionCode) {
            // 已有检验单，批量保存
            const baseInfo = this.validateAndBuildBaseInfo()
            if (!baseInfo) return

            const itemList = newItems.map((item) => ({
              inspectionCode: this.inspectionCode,
              defectIssuesCode: item.defectIssuesCode,
              otherProblemDesc: item.otherProblemDesc || '',
              issueType: 'B',
              quantity: 1
            }))

            this.loadingOpen()
            try {
              const res = await this.$api.materialInspectionDefectAdd({
                itemList,
                baseInfo
              })

              if (res.status === 200) {
                this.$message.success(this.$l('tips_add_success') || '添加成功')
                await this.loadMajorIssueList()
                await this.getData()
              } else {
                this.$message.error(res.msg || '添加失败')
              }
            } catch (error) {
              this.$message.error(error.message || '添加失败')
            } finally {
              this.loadingClose()
            }
          } else {
            // 未保存检验单，添加到本地列表
            newItems.forEach((item) => {
              const existingIndex = this.majorIssueList.findIndex(
                (i) => i.defectIssuesCode === item.defectIssuesCode
              )
              if (existingIndex !== -1) {
                this.majorIssueList.splice(existingIndex, 1, {
                  ...this.majorIssueList[existingIndex],
                  ...item,
                  quantity: 1
                })
                return
              }
              this.majorIssueList.push({ ...item, quantity: 1 })
            })
          }
        }
      } else if (issueType === 'D') {
        // 疵点明细
        if (this.inspectionCode) {
          // 已有检验单，批量保存
          // 先计算添加后的不良数量
          const currentTotal = this.defectIssueList.reduce(
            (sum, item) => sum + (Number(item.quantity) || 0),
            0
          )
          // 每个新添加的项数量都是1
          const newTotalDefectiveQuantity = currentTotal + items.length
          
          const baseInfo = this.validateAndBuildBaseInfo()
          if (!baseInfo) return

          // 更新baseInfo中的不良数量为添加后的值
          baseInfo.totalDefectiveQuantity = newTotalDefectiveQuantity

          const itemList = items.map((item) => ({
            inspectionCode: this.inspectionCode,
            defectIssuesCode: item.defectIssuesCode,
            issueType: 'D',
            quantity: 1
          }))

          this.loadingOpen()
          try {
            const res = await this.$api.materialInspectionDefectAdd({
              itemList,
              baseInfo
            })

            if (res.status === 200) {
              this.$message.success(this.$l('tips_add_success') || '添加成功')
              await this.loadDefectIssueList()
              await this.getData()
            } else {
              this.$message.error(res.msg || '添加失败')
            }
          } catch (error) {
            this.$message.error(error.message || '添加失败')
          } finally {
            this.loadingClose()
          }
        } else {
          // 未保存检验单，添加到本地列表
          items.forEach((item) => {
            const existingIndex = this.defectIssueList.findIndex(
              (i) => i.defectIssuesCode === item.defectIssuesCode
            )
            if (existingIndex !== -1) {
              this.defectIssueList[existingIndex].quantity += 1
            } else {
              this.defectIssueList.push({ ...item, quantity: 1 })
            }
          })
          this.updateDefectQuantity()
        }
      }
    },
    validateAndBuildNewSaveParams() {
      if (!this.formData.arrivalDate) {
        this.$message.warning(
          this.$l('tips_select_arrivalDate') || '请选择到料日期'
        )
        return null
      }
      if (!this.formData.totalArrivalQuantity) {
        this.$message.warning(
          this.$l('tips_input_totalArrivalQuantity') || '请输入来料总量'
        )
        return null
      }
      if (!this.formData.whReceiverList?.length) {
        this.$message.warning(
          this.$l('form_placeholder_whReceiverNames') || '请选择仓库收货人员'
        )
        return null
      }

      const params = {
        ...this.formData,
        arrivalDate: dayjs(this.formData.arrivalDate).format('YYYY-MM-DD'),
        whReceiverNames: this.formData.whReceiverNames,
        purchaseMaterialCode: this.formData.purchaseMaterialCode,
        purchaseMaterialDetailCode: this.formData.purchaseMaterialDetailCode,
        inspectionCode: this.inspectionCode,
        majorIssueList: this.majorIssueList,
        defectIssueList: this.defectIssueList
      }
      return params
    },
    validateAndBuildBaseInfo() {
      // 验证必填字段
      if (!this.formData.arrivalDate) {
        this.$message.warning(
          this.$l('tips_select_arrivalDate') || '请选择到料日期'
        )
        return null
      }
      if (!this.formData.inspectionDate) {
        this.$message.warning(
          this.$l('tips_select_inspectionDate') || '请选择检验日期'
        )
        return null
      }
      if (!this.formData.totalArrivalQuantity) {
        this.$message.warning(
          this.$l('tips_input_totalArrivalQuantity') || '请输入来料总量'
        )
        return null
      }
      if (!this.formData.totalInspectQuantity) {
        this.$message.warning(
          this.$l('tips_input_totalInspectQuantity') || '请输入抽检数量'
        )
        return null
      }
      if (
        !this.formData.reporterList ||
        this.formData.reporterList.length === 0
      ) {
        this.$message.warning(
          this.$l('tips_select_reporterNames') || '请选择检验人员'
        )
        return null
      }

      const arrivalQty = Number(this.formData.totalArrivalQuantity) || 0
      const inspectQty = Number(this.formData.totalInspectQuantity) || 0
      const defectQty = Number(this.formData.totalDefectiveQuantity) || 0

      // 验证规则
      if (inspectQty > arrivalQty) {
        this.$message.warning(
          this.$l('tips_inspect_gt_arrival') || '抽检数量不能大于来料总量'
        )
        return null
      }
      if (defectQty > inspectQty) {
        this.$message.warning(
          this.$l('tips_defect_gt_inspect') || '抽检数量不能小于不良数量'
        )
        return null
      }

      // 检验日期验证
      const arrivalDate = dayjs(this.formData.arrivalDate)
      const inspectionDate = dayjs(this.formData.inspectionDate)
      const today = dayjs()

      if (inspectionDate.isAfter(today, 'day')) {
        this.$message.warning(
          this.$l('tips_inspection_date_gt_today') || '检验日期不能大于当前日期'
        )
        return null
      }
      if (inspectionDate.isBefore(arrivalDate, 'day')) {
        this.$message.warning(
          this.$l('tips_inspection_date_lt_arrival') ||
            '检验日期不能小于到料日期'
        )
        return null
      }

      // 构建参数
      const reporterNames = (this.formData.reporterList || [])
        .map((u) => u.userName + '(' + u.userNo + ')')
        .join('、')

      return {
        ...this.formData,
        arrivalDate: dayjs(this.formData.arrivalDate).format('YYYY-MM-DD'),
        inspectionDate: dayjs(this.formData.inspectionDate).format(
          'YYYY-MM-DD'
        ),
        reporterNames,
        purchaseMaterialCode: this.formData.purchaseMaterialCode,
        purchaseMaterialDetailCode: this.formData.purchaseMaterialDetailCode,
        inspectionCode: this.inspectionCode,
        majorIssueList: this.majorIssueList,
        defectIssueList: this.defectIssueList
      }
    },

    getAuditResultTypeColor(type) {
      const colorMap = {
        A: '#28A745',
        C: '#FFC107',
        R: '#DC3545'
      }
      return colorMap[type] || '#6C757D'
    },

    async save() {
      const result = await validate.formValidate([
        this.$refs.registrationForm,
        this.$refs.inspectionForm
      ])
      if (!result) return (this.backDialogVisible = false)

      // 保存前先更新不良数量，确保使用最新计算的值
      this.updateDefectQuantity()

      const params =
        this.status === 'N'
          ? this.validateAndBuildNewSaveParams()
          : this.validateAndBuildBaseInfo()
      if (!params) return

      this.loadingOpen()
      if (this.status === 'N') {
        this.$api
          .materialInspectionSaveApi({
            ...params,
            inspectionResult: this.computedInspectionResult,
            totalQualifiedRate: this.inspectionPassRate
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status === 200) {
              this.$message({
                showClose: true,
                message: res.msg || '保存成功',
                type: 'success'
              })
              if (this.inspectionCode) {
                this.getData()
              } else {
                console.log('lzq:res.body', res.body)
                this.$router.replace({
                  name: 'quality-iqcInspectionReport-detail',
                  params: { code: res.body, pageType: 'detail' },
                  query: { inspectionNo: res.body.inspectionNo }
                })
              }
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch((error) => {
            this.loadingClose()
            this.$message.error(error.message || '保存失败')
          })
      } else {
        this.$api
          .materialInspectionSaveByInventoryApi({
            ...params,
            inspectionResult: this.computedInspectionResult,
            totalQualifiedRate: this.inspectionPassRate
          })
          .then((res) => {
            this.loadingClose()
            const { status } = res
            if (status === 200) {
              this.$message({
                showClose: true,
                message: res.msg || '保存成功',
                type: 'success'
              })
              if (this.inspectionCode) {
                this.getData()
              } else {
                this.$router.replace({
                  name: 'quality-iqcInspectionReport-detail',
                  params: { code: res.body, pageType: 'detail' },
                  query: { inspectionNo: res.body.inspectionNo }
                })
              }
            } else {
              this.$message.error(res.msg)
            }
          })
          .catch((error) => {
            this.loadingClose()
            this.$message.error(error.message || '保存失败')
          })
      }
    },

    del({ inspectionCode }) {
      this.$confirm(
        this.$l('tips_delete_record') || '是否要删除该记录？',
        this.$l('dialog_title_confirm') || '确认信息',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .materialInspectionDelApi({ inspectionCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_delete_success') || '删除成功！',
              type: 'success'
            })
            this.close()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('tips_delete_failed') || '删除失败！')
          })
      })
    },

    async submit() {
      this.$confirm(
        this.$l('tips_submit_record') || '是否要审核该记录？',
        this.$l('dialog_title_confirm') || '确认信息',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(async () => {
        const result = await validate.formValidate([
          this.$refs.registrationForm,
          this.$refs.inspectionForm
        ])
        if (!result) return (this.backDialogVisible = false)

        this.loadingOpen()
        this.$api
          .materialInspectionSubmitApi({ ...this.formData })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_submit_success') || '审核成功！',
              type: 'success'
            })
            this.close()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('tips_submit_failed') || '审核失败！')
          })
      })
    },
    async submitAndInspection() {
      // 提交前先更新不良数量，确保使用最新计算的值
      this.updateDefectQuantity()
      
      const params =
        this.status === 'N'
          ? this.validateAndBuildNewSaveParams()
          : this.validateAndBuildBaseInfo()
      if (!params) return
      this.loadingOpen()
      this.$api
        .materialInspectionSubmitAndSaveApi({
          ...params,
          inspectionResult: this.computedInspectionResult,
          totalQualifiedRate: this.inspectionPassRate
        })
        .then((res) => {
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg || '操作成功！',
              type: 'success'
            })
            this.getData()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((error) => {
          this.loadingClose()
          this.$message.error(error.message || '操作失败！')
        })
        .finally(() => {
          this.loadingClose()
        })
    },
    async review() {
      this.$confirm(
        this.$l('tips_submit_record') || '是否要审核该记录？',
        this.$l('dialog_title_confirm') || '确认信息',
        {
          confirmButtonText: this.$l('btn_confirm') || '确定',
          cancelButtonText: this.$l('btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(async () => {
        const result = await validate.formValidate([
          this.$refs.registrationForm,
          this.$refs.inspectionForm
        ])
        if (!result) return (this.backDialogVisible = false)

        this.loadingOpen()
        this.$api
          .materialInspectionReviewApi({ inspectionCode: this.inspectionCode })
          .then(() => {
            this.loadingClose()
            this.$message({
              showClose: true,
              message: this.$l('tips_submit_success') || '审核成功！',
              type: 'success'
            })
            this.close()
          })
          .catch(() => {
            this.loadingClose()
            this.$message.error(this.$l('tips_submit_failed') || '审核失败！')
          })
      })
    },
    async submitAndAudit() {
      // 提交前先更新不良数量，确保使用最新计算的值
      this.updateDefectQuantity()
      
      // 验证基础信息
      const params =
        this.status === 'N'
          ? this.validateAndBuildNewSaveParams()
          : this.validateAndBuildBaseInfo()
      if (!params) return

      const inspectQty = Number(this.formData.totalInspectQuantity) || 0
      const defectQty = Number(this.formData.totalDefectiveQuantity) || 0

      // 判定合格率
      const qualifiedQty = inspectQty - defectQty
      const qualifiedRate = inspectQty > 0 ? (qualifiedQty / inspectQty) * 100 : 0

      // 判定结果
      let isQualified = false
      let resultText = ''

      // 只要出现一条重大问题，直接判定不合格
      if (this.majorIssueList.length > 0) {
        isQualified = false
        resultText = '质检不合格'
      } else {
        // 没有重大问题时，抽检合格率 >= 95%，判定合格，否则判定不合格
        if (qualifiedRate >= 95) {
          isQualified = true
          resultText = '质检合格'
        } else {
          isQualified = false
          resultText = '质检不合格'
        }
      }

      if (isQualified) {
        // 合格，二次确认
        this.$confirm(
          `本次辅料检验报告判定结果为【${resultText}】，是否正式提交辅料检验报告？`,
          '提交确认',
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
        )
          .then(() => {
            this.doSubmitAndAudit(params, 'A')
          })
          .catch(() => {})
      } else {
        // 不合格，显示处理方式抽屉
        this.unqualifiedDrawerVisible = true
      }
    },
    async doSubmitAndAudit(params, status, extraParams = {}) {
      this.loadingOpen()
      this.$api
        .materialInspectionSaveAndSubmitByInventoryApi({
          ...params,
          inspectionResult: this.computedInspectionResult,
          totalQualifiedRate: this.inspectionPassRate,
          status,
          ...extraParams
        })
        .then((res) => {
          this.loadingClose()
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: res.msg || '操作成功！',
              type: 'success'
            })
            this.getData()
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch((error) => {
          this.loadingClose()
          this.$message.error(error.message || '操作失败！')
        })
        .finally(() => {
          this.loadingClose()
        })
    },
    handleUnqualifiedConfirm(data) {
      // 提交前先更新不良数量，确保使用最新计算的值
      this.updateDefectQuantity()
      
      const params =
        this.status === 'N'
          ? this.validateAndBuildNewSaveParams()
          : this.validateAndBuildBaseInfo()
      if (!params) return

      const { status, applicationRemark, inspectionDefect } = data
      const extraParams = {
        applicationRemark
      }

      if (inspectionDefect) {
        extraParams.inspectionDefect = inspectionDefect
      }

      this.doSubmitAndAudit(params, status, extraParams)
      this.unqualifiedDrawerVisible = false
    },
    close() {
      this.$emit('close')
    },

    openChooseMaterial() {
      if (this.disabled) return
      this.chooseMaterialVisible = true
    },

    chooseMaterialConfirm(data) {
      this.chooseMaterialVisible = false

      const {
        purchaseMaterialCode,
        purchaseMaterialDetailCode,
        materialNo,
        materialName,
        cd,
        materialDesc,
        materialRequirement,
        series,
        purchaseMaterialNo,
        buyerName,
        scmName,
        purchaserEntityName,
        originOrderNo,
        qtyUnit,
        arrivalDate,
        totalArrivalQuantity
      } = data

      this.formData = {
        ...this.formData,
        purchaseMaterialCode,
        purchaseMaterialDetailCode,
        materialNo,
        materialName,
        cd,
        materialDesc,
        materialRequirement,
        series,
        purchaseMaterialNo,
        buyerName,
        scmName,
        purchaserEntityName,
        originOrderNo,
        qtyUnit,
        arrivalDate: arrivalDate || this.formData.arrivalDate,
        totalArrivalQuantity:
          totalArrivalQuantity || this.formData.totalArrivalQuantity
      }
    },

    chooseUserConfirm(data) {
      this.userNameList = data
        ? data.map((item) => item.userName + '(' + item.userNo + ')')
        : []
      this.formData.reporterNames = [...new Set(this.userNameList || [])].join(
        '、'
      )
      this.formData = {
        ...this.formData,
        reporterList: data.map((item) => ({
          userCode: item.userCode,
          userName: item.userName,
          userNo: item.userNo,
          reporterType: 'I'
        }))
      }
    },

    chooseWhReceiverConfirm(data) {
      const whReceiverNameList = data
        ? data.map((item) => item.userName + '(' + item.userNo + ')')
        : []
      this.formData.whReceiverNames = [
        ...new Set(whReceiverNameList || [])
      ].join('、')
      this.formData = {
        ...this.formData,
        whReceiverList: data.map((item) => ({
          userCode: item.userCode,
          userName: item.userName,
          userNo: item.userNo,
          reporterType: 'W'
        }))
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-form-container {
  .section {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 10px;
    margin-top: 10px;
  }

  .section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;

    .header-left {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    .section-title {
      margin: 0;
    }

    .section-desc {
      font-size: 12px;
      font-weight: 600;
      color: #fa5c7c;
    }

    .header-right {
      display: flex;
      gap: 10px;
    }
  }

  .inspection-info {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    padding: 12px 16px;
    background-color: #f9f9f9;
    border-radius: 4px;
    font-size: 13px;

    .info-item {
      display: flex;
      align-items: center;

      .info-label {
        color: #606266;
        opacity: 0.8;
      }

      .info-value {
        font-weight: 600;
        color: #333;
      }
    }
  }

  :deep(.result-qualified input) {
    color: #28a745 !important;
    font-weight: 600;
  }

  :deep(.result-unqualified input) {
    color: #fe2812 !important;
    font-weight: 600;
  }

  :deep(.result-defective input) {
    color: #f95271 !important;
    font-weight: 600;
  }

  :deep(.defective-quantity input) {
    color: #f95271 !important;
    font-weight: 600;
  }
}
</style>
